import { render, staticRenderFns } from "./NewAcctForInternalClient.vue?vue&type=template&id=36f57a2d&scoped=true&"
import script from "./NewAcctForInternalClient.vue?vue&type=script&lang=js&"
export * from "./NewAcctForInternalClient.vue?vue&type=script&lang=js&"
import style0 from "./NewAcctForInternalClient.vue?vue&type=style&index=0&id=36f57a2d&style=scss&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f57a2d",
  null
  
)

export default component.exports